import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzK9Drsl } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_K9_DRSL: Record<
  PageIdWoofzK9Drsl,
  TPageConfig
> = {
  [PageIdWoofzK9Drsl.DOG_AGE_K9_DRSL]: {
    id: PageIdWoofzK9Drsl.DOG_AGE_K9_DRSL,
    hasHeader: true,
  },
  [PageIdWoofzK9Drsl.DOG_SEX_K9_DRSL]: {
    id: PageIdWoofzK9Drsl.DOG_SEX_K9_DRSL,
    hasHeader: true,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9Drsl.DOG_BREED_K9_DRSL]: {
    id: PageIdWoofzK9Drsl.DOG_BREED_K9_DRSL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9Drsl.DOG_BREED_ID_K9_DRSL]: {
    id: PageIdWoofzK9Drsl.DOG_BREED_ID_K9_DRSL,
  },
  [PageIdWoofzK9Drsl.URGE_K9_DRSL]: {
    id: PageIdWoofzK9Drsl.URGE_K9_DRSL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9Drsl.CHALLENGES_K9_DRSL]: {
    id: PageIdWoofzK9Drsl.CHALLENGES_K9_DRSL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9Drsl.URGE_1_K9_DRSL]: {
    id: PageIdWoofzK9Drsl.URGE_1_K9_DRSL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9Drsl.LEASH_PULLING_K9_DRSL]: {
    id: PageIdWoofzK9Drsl.LEASH_PULLING_K9_DRSL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9Drsl.URGE_LEASH_K9_DRSL]: {
    id: PageIdWoofzK9Drsl.URGE_LEASH_K9_DRSL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9Drsl.DURING_WALK_K9_DRSL]: {
    id: PageIdWoofzK9Drsl.DURING_WALK_K9_DRSL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9Drsl.URGE_NOT_ALONE_K9_DRSL]: {
    id: PageIdWoofzK9Drsl.URGE_NOT_ALONE_K9_DRSL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9Drsl.AGRESSIVE_BEHAVIOR_K9_DRSL]: {
    id: PageIdWoofzK9Drsl.AGRESSIVE_BEHAVIOR_K9_DRSL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9Drsl.TRIGGERS_K9_DRSL]: {
    id: PageIdWoofzK9Drsl.TRIGGERS_K9_DRSL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9Drsl.URGE_2_K9_DRSL]: {
    id: PageIdWoofzK9Drsl.URGE_2_K9_DRSL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9Drsl.BEHAVIOR_ISSUES_K9_DRSL]: {
    id: PageIdWoofzK9Drsl.BEHAVIOR_ISSUES_K9_DRSL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9Drsl.DOG_ACT_K9_DRSL]: {
    id: PageIdWoofzK9Drsl.DOG_ACT_K9_DRSL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9Drsl.DOG_OFF_AT_HOME_K9_DRSL]: {
    id: PageIdWoofzK9Drsl.DOG_OFF_AT_HOME_K9_DRSL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9Drsl.REWARDS_K9_DRSL]: {
    id: PageIdWoofzK9Drsl.REWARDS_K9_DRSL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9Drsl.IGNORE_COMMANDS_K9_DRSL]: {
    id: PageIdWoofzK9Drsl.IGNORE_COMMANDS_K9_DRSL,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzK9Drsl.COMMANDS_61_K9_DRSL]: {
    id: PageIdWoofzK9Drsl.COMMANDS_61_K9_DRSL,
    hasHeader: true,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9Drsl.COMMANDS_62_K9_DRSL]: {
    id: PageIdWoofzK9Drsl.COMMANDS_62_K9_DRSL,
    hasHeader: true,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9Drsl.COMMANDS_63_K9_DRSL]: {
    id: PageIdWoofzK9Drsl.COMMANDS_63_K9_DRSL,
    hasHeader: true,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9Drsl.URGE_3_K9_DRSL]: {
    id: PageIdWoofzK9Drsl.URGE_3_K9_DRSL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9Drsl.PREPARE_SCREEN_K9_DRSL]: {
    id: PageIdWoofzK9Drsl.PREPARE_SCREEN_K9_DRSL,
    hasHeader: true,
  },
  [PageIdWoofzK9Drsl.DOG_PROFILE_K9_DRSL]: {
    id: PageIdWoofzK9Drsl.DOG_PROFILE_K9_DRSL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9Drsl.URGE_REVIEWED_K9_DRSL]: {
    id: PageIdWoofzK9Drsl.URGE_REVIEWED_K9_DRSL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9Drsl.PREPARE_FLOW_K9_DRSL]: {
    id: PageIdWoofzK9Drsl.PREPARE_FLOW_K9_DRSL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9Drsl.EMAIL_K9_DRSL]: {
    id: PageIdWoofzK9Drsl.EMAIL_K9_DRSL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9Drsl.NEWSLETTER_URGE_K9_DRSL]: {
    id: PageIdWoofzK9Drsl.NEWSLETTER_URGE_K9_DRSL,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzK9Drsl.WELCOME_TO_WOOFZ_K9_DRSL]: {
    id: PageIdWoofzK9Drsl.WELCOME_TO_WOOFZ_K9_DRSL,
    hasHeader: true,
  },
  [PageIdWoofzK9Drsl.SUBSCRIPTIONS_K9_DRSL]: {
    id: PageIdWoofzK9Drsl.SUBSCRIPTIONS_K9_DRSL,
  },
  [PageIdWoofzK9Drsl.CHAT_UPSELL_K9_DRSL]: {
    id: PageIdWoofzK9Drsl.CHAT_UPSELL_K9_DRSL,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzK9Drsl.UPSELL_K9_DRSL]: {
    id: PageIdWoofzK9Drsl.UPSELL_K9_DRSL,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzK9Drsl.UPSELL_FEEDING_GUIDE_K9_DRSL]: {
    id: PageIdWoofzK9Drsl.UPSELL_FEEDING_GUIDE_K9_DRSL,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzK9Drsl.UPSELL_EMOTIONAL_SUPPORT_K9_DRSL]: {
    id: PageIdWoofzK9Drsl.UPSELL_EMOTIONAL_SUPPORT_K9_DRSL,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzK9Drsl.DOWNLOAD_K9_DRSL]: {
    id: PageIdWoofzK9Drsl.DOWNLOAD_K9_DRSL,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzK9Drsl.ACCOUNT_K9_DRSL]: {
    id: PageIdWoofzK9Drsl.ACCOUNT_K9_DRSL,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
